import { render } from "./Slogan3.vue?vue&type=template&id=6173a054&scoped=true&lang=true"
import script from "./Slogan3.vue?vue&type=script&lang=js"
export * from "./Slogan3.vue?vue&type=script&lang=js"

import "./Slogan3.vue?vue&type=style&index=0&id=6173a054&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6173a054"]])

export default __exports__